import { DataService } from './data.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class ActionService extends DataService {
  constructor(http: HttpClient, private localHttp : HttpClient) { 
    super('action', http);
  }
}
